import { NOTIFICATION_DURATION } from '@/js/constants/index.js';
import app from '@/js/app.js';

const notify = ({
  text = '',
  position = 'top',
  closeButton = false,
  closeButtonText = 'Close',
  closeButtonColor = 'white',
  duration = NOTIFICATION_DURATION,
  cb = () => null
}) => {
  app.$f7.toast
    .create({
      text: text,
      position: position,
      closeButton: closeButton,
      closeButtonText: closeButtonText,
      closeButtonColor: closeButtonColor,
      destroyOnClose: true,
      closeTimeout: duration,
      on: {
        close() {
          cb();
        }
      }
    })
    .open();
};

export default notify;
